import axios from "axios";

export default function getSoAttributeList(sku) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/shipping-order/attributes`, {
        sku,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
